// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__36QUX","modalForm":"UpgradeEpcsModal_modalForm__2vPsd","modalFooter":"UpgradeEpcsModal_modalFooter__2eOKX"};